module.exports = __webpack_public_path__ + "img/amusement.3d21f74d.svg";